module.exports = __webpack_public_path__ + "static/media/cq_tutti.64c2ad30.svg";